export default value => moment(value).format(FORMAT_DATETIME)
